import { Injectable } from '@angular/core';
import { ModalEvent, ModalOverlayService } from '@woolworthsnz/styleguide';
import { SavedRecipesResponse } from '@woolworthsnz/trader-api';
import { catchError, map, Observable, switchMap } from 'rxjs';
import { Stamp } from '../models';
import { RecipeService } from './recipe.service';

@Injectable({ providedIn: 'root' })
export class SaveRecipeService {
	constructor(private recipeService: RecipeService, private modalOverlayService: ModalOverlayService) {}

	// Returns an updated list of saved recipe id's
	public saveOrUnsaveRecipe({ id, isSaved }: { id: number; isSaved: boolean }): Observable<number[]> {
		const saveOrRemove = isSaved ? this.recipeService.removeSavedRecipe(id) : this.recipeService.saveRecipe(id);

		return saveOrRemove.pipe(
			catchError((err) => {
				if (err.status === 401) {
					this.modalOverlayService.open({
						eventType: ModalEvent.saveRecipe,
					});
				}
				return this.fetchSavedRecipes();
			}),
			switchMap(() => this.fetchSavedRecipes())
		);
	}

	public fetchSavedRecipes(): Observable<number[]> {
		return this.recipeService
			.getSavedRecipes()
			.pipe(
				map(
					(savedRecipes: SavedRecipesResponse) =>
						(savedRecipes.savedRecipes?.map((recipe) => recipe.recipeId).filter(Boolean) as number[]) || []
				)
			);
	}
}

export function mergeStampsWithSavedRecipeIds(stampList: Stamp[], ids: number[]): Stamp[] {
	return stampList.map((stamp) => ({ ...stamp, recipe: { ...stamp.recipe, saved: ids.includes(stamp.recipe.id) } }));
}
